/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Body1Inputs */

const en_formatter_body1 = /** @type {(inputs: Formatter_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatting JSON is a parse and re-serialize round trip, not a text transformation. The input is parsed into values, then written back out with the indentation you chose. That distinction matters more than it sounds: anything that is not part of the parsed value cannot survive the trip, and anything the parser normalizes stays normalized in the output.`)
};

const ko_formatter_body1 = /** @type {(inputs: Formatter_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 포매팅은 텍스트 변환이 아니라 파싱 후 재직렬화하는 왕복 과정입니다. 입력을 값으로 파싱한 뒤 선택한 들여쓰기로 다시 씁니다. 이 차이는 생각보다 중요합니다. 파싱된 값에 속하지 않는 것은 왕복을 살아남지 못하고, 파서가 정규화하는 것은 출력에서도 정규화된 상태로 남습니다.`)
};

const ja_formatter_body1 = /** @type {(inputs: Formatter_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON の整形はテキスト変換ではなく、パースして再シリアライズする往復処理です。入力を値としてパースし、選んだインデントで書き戻します。この違いは見た目以上に重要です。パースされた値に属さないものは往復を生き残れず、パーサが正規化するものは出力でも正規化されたままになります。`)
};

/**
* | output |
* | --- |
* | "Formatting JSON is a parse and re-serialize round trip, not a text transformation. The input is parsed into values, then written back out with the indentatio..." |
*
* @param {Formatter_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_body1 = /** @type {((inputs?: Formatter_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_body1(inputs)
	if (locale === "ko") return ko_formatter_body1(inputs)
	return ja_formatter_body1(inputs)
});